import './App.css';
import { Link } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { loadAllPosts, BlogPostMetadata } from './data/postsLoader';

function Blog(): React.JSX.Element {
  const [blogPosts, setBlogPosts] = useState<BlogPostMetadata[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const [selectedCategory, setSelectedCategory] = useState<string>('All');
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Load blog posts on component mount
  useEffect(() => {
    loadAllPosts()
      .then(posts => {
        setBlogPosts(posts);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading blog posts:', error);
        setLoading(false);
      });
  }, []);

  // Get unique categories from blog posts
  const categories = ['All', ...Array.from(new Set(blogPosts.map(post => post.category)))];

  // Filter blog posts based on selected category
  const filteredPosts = selectedCategory === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="App blog-page-static">
      <section className="blog-page">
        <div className="blog-header">
          <h1 className="section-title">Blog</h1>
          <p className="blog-intro">
            Engineering, markets, psychology, and shower thoughts.
          </p>
        </div>
        <div className="blog-content-wrapper">
          <div className="blog-filter-container">
            <div className={`blog-filter-dropdown ${isDropdownOpen ? 'open' : ''}`} ref={dropdownRef}>
              <button
                className="blog-filter-select"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                type="button"
              >
                {selectedCategory}
                <span className="blog-filter-arrow">▼</span>
              </button>
              {isDropdownOpen && (
                <div className="blog-filter-options">
                  {categories.map((category) => (
                    <button
                      key={category}
                      className={`blog-filter-option ${selectedCategory === category ? 'selected' : ''}`}
                      onClick={() => {
                        setSelectedCategory(category);
                        setIsDropdownOpen(false);
                      }}
                      type="button"
                    >
                      {category}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="blog-posts">
          {loading ? (
            <p style={{ color: '#ffffff' }}>Loading...</p>
          ) : filteredPosts.length === 0 ? (
            <p style={{ color: '#ffffff' }}>No posts found.</p>
          ) : (
            filteredPosts.map((post) => (
              <Link key={post.id} to={`/blog/${post.id}`} className="blog-post-card">
                <div className="blog-post-header">
                  <span className="blog-category">{post.category}</span>
                  <span className="blog-date">{post.date}</span>
                </div>
                <h2 className="blog-post-title">{post.title}</h2>
                <p className="blog-post-excerpt">{post.excerpt}</p>
              </Link>
            ))
          )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Blog;

